/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Group, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import DeleteConfirmPopover from '../../../../../../../components/DeleteConfirmPopover';
import { EntityPaymentMethodType } from '../../../../../../../models/core/entities.type';
import theme from '../../../../../../../theme';

type DataViewActionProps = {
  item: EntityPaymentMethodType;
  confirmActionResult(item: EntityPaymentMethodType | null, action: string, confirmed: boolean): void;
};

export default function PaymentMethodFormViewActions(props: DataViewActionProps) {
  return (
    <Group>
      <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Editar">
        <ActionIcon
          size="sm"
          color="primary"
          style={{ borderColor: theme?.colors?.accent?.[6] }}
          variant="outline"
          onClick={() => {
            props.confirmActionResult(props.item, 'editar', true);
          }}
        >
          <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
        </ActionIcon>
      </Tooltip>
      <DeleteConfirmPopover
        label="Excluir"
        message="Esta ação removerá a forma de pagamento."
        variant="outline"
        onConfirm={() => {
          props.confirmActionResult(props.item, 'excluir', true);
        }}
        onCancel={() => {
          props.confirmActionResult(props.item, 'excluir', false);
        }}
      />
    </Group>
  );
}
